import React from 'react';
import type { BomPart } from '../../services/industrializationService';
import { CostConfirmBar, GenerateButton, MOB_COLORS, ToVerifyBadge, type StepProps } from './shared';

const MakeOrBuyStep: React.FC<StepProps> = ({
  dossier,
  isRunning,
  costEstimate,
  showCostConfirm,
  onRequestGenerate,
  onConfirmGenerate,
  onCancelGenerate,
}) => {
  const bom: BomPart[] = dossier?.bom ?? [];
  const hasBom = bom.length > 0;

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-semibold text-slate-700">Step 3 — Make-or-Buy Analysis</h3>
        {showCostConfirm ? (
          <CostConfirmBar
            costEstimate={costEstimate}
            confirmLabel="Analyze Make-or-Buy"
            onConfirm={onConfirmGenerate}
            onCancel={onCancelGenerate}
          />
        ) : (
          <GenerateButton
            label="Analyze Make-or-Buy"
            isRunning={isRunning}
            onRequest={onRequestGenerate}
            disabled={!hasBom}
          />
        )}
      </div>

      {hasBom ? (
        <table className="w-full text-xs border-collapse">
          <thead>
            <tr className="bg-slate-100">
              <th className="text-left py-1 px-2 font-medium text-slate-600">Part</th>
              <th className="text-left py-1 pr-2 font-medium text-slate-600">Decision</th>
              <th className="text-left py-1 font-medium text-slate-600">Rationale</th>
            </tr>
          </thead>
          <tbody>
            {bom.map(part => (
              <tr key={part.id} className="border-b border-slate-100 hover:bg-slate-50">
                <td className="py-1 px-2 text-xs">
                  {part.name}
                  {part.to_verify && <ToVerifyBadge />}
                </td>
                <td className={`py-1 pr-2 text-xs ${MOB_COLORS[part.make_or_buy] ?? ''}`}>
                  {part.make_or_buy.toUpperCase()}
                </td>
                <td className="py-1 text-xs text-slate-500">{part.make_buy_rationale ?? '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p className="text-xs text-slate-400 italic">
          Generate the BoM first (Step 2), then run the Make-or-Buy analysis.
        </p>
      )}
    </div>
  );
};

export default MakeOrBuyStep;
